/*
 * Hides the "shipping calculated at checkout" notes once the cart reaches free shipping.
 *
 * The notes are server-rendered already hidden or visible. This script only covers the
 * pages that are NOT re-rendered after an add-to-cart (the product page), where the
 * cart can cross the goal without a reload. Cart drawer and cart page re-render in
 * Liquid and need nothing from here.
 */

if (!window.freeShippingNoteLoaded) {
  window.freeShippingNoteLoaded = true;

  const FREE_SHIPPING_VALUE_KEYS = { quantity: 'item_count', amount: 'total_price' };

  // /cart/change.js publishes the whole cart, /cart/add.js only the added line.
  const readFreeShippingCart = async (event) => {
    const published = event?.cartData;
    if (published && typeof published.total_price === 'number') return published;

    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      return null;
    }
  };

  const syncFreeShippingNotes = async (event) => {
    const notes = document.querySelectorAll('[data-free-shipping-note]');
    if (notes.length === 0) return;

    const cart = await readFreeShippingCart(event);
    if (!cart) return;

    notes.forEach((note) => {
      const goal = Number(note.dataset.threshold) || 0;
      const key = FREE_SHIPPING_VALUE_KEYS[note.dataset.goalType] || FREE_SHIPPING_VALUE_KEYS.amount;
      note.classList.toggle('hidden', goal > 0 && cart[key] >= goal);
    });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncFreeShippingNotes);
  }
}
